import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center gap-x-2 gap-y-1 whitespace-nowrap rounded-md p-3 font-normal ring-offset-background transition-colors *:h-full *:w-full *:justify-center hover:brightness-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:brightness-active disabled:pointer-events-none disabled:opacity-50 sm:gap-x-4 sm:gap-y-2',
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-foreground',
        secondary: 'bg-secondary text-secondary-foreground',
        outline:
          'border border-primary text-primary hover:bg-primary hover:text-primary-foreground',
        ghost: '',
        muted: 'cursor-auto bg-muted text-muted-foreground hover:filter-none',
        destructive: 'bg-destructive text-destructive-foreground',
        navigation:
          'rounded-r-none border-r border-muted bg-popover hover:bg-accent group-[.active]:cursor-auto group-[.active]:border-accent-foreground group-[.active]:bg-accent group-[.active]:text-accent-foreground',
        link: 'text-accent-foreground underline-offset-4 hover:underline',
      },
      size: {
        small: 'h-7 px-3 text-sm sm:h-8',
        base: 'h-10 px-4 text-base',
        large: 'h-12 px-6 text-sm sm:text-lg',
        huge: 'aspect-square h-48 text-lg',
      },
      width: {
        auto: 'w-auto',
        full: 'w-full',
        icon: 'aspect-square px-2',
      },
      justify: {
        center: 'justify-center',
        start: 'justify-start *:w-auto',
        between: 'justify-between *:w-auto',
      },
      orientation: {
        horizontal: '',
        vertical: 'h-auto flex-col *:h-6',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'base',
      width: 'auto',
      justify: 'center',
      orientation: 'horizontal',
    },
    compoundVariants: [
      {
        width: 'icon',
        size: 'small',
        className: 'p-2',
      },
      {
        orientation: 'vertical',
        size: 'small',
        className: 'gap-y-1',
      },
      {
        orientation: 'vertical',
        size: ['large', 'huge'],
        className: '*:h-6 sm:*:h-8',
      },
      {
        orientation: 'vertical',
        size: 'huge',
        className: 'h-20 sm:h-48',
      },
    ],
  },
);
